var jlHeader = {
  load:function(){
  //  this.employerLinks();
    this.headerSearch();
    this.headerMenu();
  },
  headerMenu:function(){
    var menuEl = document.getElementById("jlMenu");
    var items = menuEl.querySelectorAll("li");
    for(let l of items){
      if(l.getAttribute("data-loaderLink"))
      {
        l.addEventListener("click",(e)=>{
          e.preventDefault();
          jlLoader.show(e.currentTarget.getAttribute("data-loaderLink"));
          var link = e.currentTarget.querySelector("a").getAttribute("href");
          setTimeout(()=>{
            parent.location = link;
          },300);

        });
      }

      l.addEventListener("mouseover",(e)=>{
        var el = e.currentTarget;
        var menuBounds = menuEl.getBoundingClientRect();
        var itemBounds = el.getBoundingClientRect();
        var elStyle = window.getComputedStyle(el.querySelector("a"));
        var elWidth = itemBounds.width - parseInt(elStyle.paddingLeft.replace("px","")) - parseInt(elStyle.paddingRight.replace("px",""));
        var elLeft = itemBounds.left - menuBounds.left+parseInt(elStyle.paddingLeft.replace("px",""));
        cssVars.set("menuFocusLeft",elLeft+"px");
        cssVars.set("menuFocusWidth",elWidth+"px");
      });


    }

    menuEl.addEventListener("mouseout",(e)=>{
      cssVars.set("menuFocusLeft","0px");
      cssVars.set("menuFocusWidth","0px");
    })
  },
  headerSearch:function(){
    var searchToggles = document.getElementsByClassName("jlHeaderSearchToggle");
    for(let l of searchToggles){
      l.addEventListener("click",function(e){
        e.preventDefault();
        //window.scrollTo({top:'0',behavior:'smooth'});

        document.getElementById("headerSearch").classList.add("show");
        scrollHash.scrollToElement('headerSearch',document.getElementById("jobsHeader").offsetHeight+document.getElementById("header_menu").offsetHeight);

      })
    }
  },
  employerLinks:function(){
    var self = this;
    window.addEventListener("hubHawaiiLogin",function(e){
      self.load();
    });
    if(hh2020Login.userData){
      fetch(JLAJAX.url+"hasListings",{
        "method":"POST",
        "headers":{
          "Content-Type":"application/json",
          "Accept":"application/json",
        },
        body:JSON.stringify({
          id:hh2020Login.userData.id,
          token:hh2020Login.userData.token,
        })
      }).then(res=>res.json())
      .then(data=>{

        var manageListingsLinks = document.getElementsByClassName("jlHasListings");
        for(l of manageListingsLinks){
          if(data.hasListings){
            l.style.display = "block";
          }
          else{
            l.style.display = "none";
          }

        }
      })
    }
  }
};
